import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Layout from '../Layout/Layout';

export default function AuthenticatingError() {
  return (
    <Layout plain>
      <h4 className="mt-5">
        <FontAwesomeIcon icon={faExclamationCircle} /> Error
      </h4>
      <p>Authenticating error</p>
      <p className="mt-5 small text-muted">
        If you feel this process is taking some time,{' '}
        <a href="/admin/">click here</a> to refresh the validation.
      </p>
    </Layout>
  );
}
